import React from 'react';
import { motion } from 'framer-motion';
import { sociallinks } from '../constants';
import {
  BsLinkedin,
  BsTwitter,
  BsInstagram,
  BsGithub,
  BsDiscord,
  BsYoutube,
} from 'react-icons/bs';
import { TbChessKingFilled } from 'react-icons/tb';
const openSocial = (link) => {
  window.open(link, '_blank');
};

const SocialMedia = () => (
  <div className="app__social">
    <motion.div
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.1, type: 'tween' }}
      onClick={() => {
        openSocial(sociallinks.twitter);
      }}
    >
      <BsTwitter />
    </motion.div>
    <motion.div
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.1, type: 'tween' }}
      onClick={() => {
        openSocial(sociallinks.linkdin);
      }}
    >
      <BsLinkedin />
    </motion.div>
    <motion.div
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.1, type: 'tween' }}
      onClick={() => {
        openSocial(sociallinks.github);
      }}
    >
      <BsGithub />
    </motion.div>
    <motion.div
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.1, type: 'tween' }}
      onClick={() => {
        openSocial(sociallinks.instagram);
      }}
    >
      <BsInstagram />
    </motion.div>
    <motion.div
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.1, type: 'tween' }}
      onClick={() => {
        openSocial(sociallinks.discord);
      }}
    >
      <BsDiscord />
    </motion.div>
    <motion.div
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.1, type: 'tween' }}
      onClick={() => {
        openSocial(sociallinks.youtube);
      }}
    >
      <BsYoutube />
    </motion.div>
    <motion.div
      whileHover={{ scale: 1.1 }}
      transition={{ duration: 0.1, type: 'tween' }}
      onClick={() => {
        openSocial(sociallinks.chess);
      }}
    >
      <TbChessKingFilled />
    </motion.div>
  </div>
);

export default SocialMedia;
